// CSS time block classes
export const CSSGhostClass = 'ghost';
export const CSSDraggedClass = 'dragged';
export const CSSDropActiveClass = 'drop-active';
export const CSSDropTargetClass = 'drop-target';
export const CSSCanDropClass = 'can-drop';
export const CSSDropOkClass = 'drop-ok';
export const CSSResizedClass = 'resized';
export const CSSHeadPart = 'head-part';
export const CSSDisplayTimeBlockDuration = 'display-time-block-duration';
export const CSSActiveClass = 'active';
export const CSSPressedClass = 'pressed';
export const CSSNewClass = 'new';
export const CSSHighlightedClass = 'highlighted';
export const CSSSmallTimeBlockClass = 'small-time-block';
export const CSSFixIntervalTimeBlockOverflowsLeftClass = 'overflows-left';
export const CSSFixIntervalTimeBlockOverflowsRightClass = 'overflows-right';
export const CSSHasPrevPart = 'has-prev-part';
export const CSSHasNextPart = 'has-next-part';
export const CSSHasPrevWeekPart = 'has-prev-week-part';
export const CSSHasNextWeekPart = 'has-next-week-part';
export const CSSTrackedTimeBlock = 'tracked-time-block';
export const CSSDefaultTimeBlock = 'default-time-block';

// CSS calendar selector
export const CalendarHeaderCSSId = '#calendar-header-scroll-container';
export const CalendarBodyCSSId = '#shive-calendar-body';
export const NowIndicatorCSSId = '#now-indicator';
export const FixIntervalCalendarContainerId = '#fix-interval'; // Wrapper for fixed-col and fix-interval-item-container
export const FixIntervalCalendarContainerExpandable = 'expandable';
export const MonthViewTimeBlockContainer = 'time-block-container';
export const TimeBlockDialogCSSSelector = '.time-entry-dialog-wrapper .k-dialog';
export const CssDropzone = 'dropzone';
export const ShowMoreButtonCSSSelector = 'show-more-events';

// CSS calendar and time block values
export const DayOrWeekVariableIntervalTimeBlockGapPx = 6;
export const FixIntervalContainerMinimumHeight = 26;
export const HorizontalTimeBlockGapPx = 2;

// We use this variable for the full day container height calculation since we cannot access the time blocks height.
export const FixIntervalTimeBlockHeightPx = 22;
export const FixIntervalContainerTopSpacing = 0;
export const FixIntervalContainerBottomSpacing = 2;
export const HorizontalDragTolerance = 40;
